import React, { useState } from "react";
import { FindWordSearchResultPage } from "./FindWordSearchResultPage";

export const FindWord = ({ showResult, setShowResult }: { showResult: boolean, setShowResult: (show: boolean) => void }) => {
    const [searchWord, setSearchWord] = useState("");

    return !showResult ? (
        <div style={{ minHeight: 'calc(100vh - 160px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20, position: 'relative', overflow: 'hidden' }}>
            <h1 style={{ marginBottom: 24, textAlign: 'center' }}>Find A Word</h1>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 20, width: '100%', maxWidth: 600 }}>
                <input
                    value={searchWord}
                    onChange={(e) => setSearchWord(e.target.value)}
                    placeholder="Type a word to find its occurrences across IELTS articles..."
                    aria-label="search"
                    style={{
                        flex: 1,
                        padding: '12px 16px',
                        fontSize: 18,
                        borderRadius: 24,
                        border: '1px solid #dfe1e5',
                        boxShadow: '0 1px 6px rgba(32,33,36,0.12)',
                        outline: 'none'
                    }}
                />

                <button
                    type="submit"
                    style={{
                        padding: '10px 18px',
                        fontSize: 16,
                        borderRadius: 24,
                        border: 'none',
                        background: '#1a73e8',
                        color: '#fff',
                        cursor: 'pointer'
                    }}
                    onClick={() => setShowResult(true)}
                >
                    Search
                </button>
            </div>
            {/* <Dandelions count={10} /> */}
        </div>) : (
        <FindWordSearchResultPage />
    );
}

export default FindWord;

function Dandelions({ count = 8 }: { count?: number }) {
    const seeds = React.useMemo(() =>
        Array.from({ length: count }).map((_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * -20,
            dur: 8 + Math.random() * 12,
            size: 14 + Math.random() * 30,
            drift: (Math.random() - 0.5) * 80,
        })),
        [count]
    );

    return (
        <div aria-hidden style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
            <style>{`
                @keyframes floatUp {
                  0% { transform: translateY(0) rotate(0deg); opacity: 1 }
                  100% { transform: translateY(-120vh) rotate(360deg); opacity: 0 }
                }
                .dandelion { position: absolute; bottom: -10vh; transform-origin: center; }
            `}</style>
            {seeds.map(s => (
                <div
                    key={s.id}
                    className="dandelion"
                    style={{
                        left: `${s.left}%`,
                        width: s.size,
                        height: s.size,
                        animation: `floatUp ${s.dur}s linear ${s.delay}s infinite`,
                        transform: `translateX(${s.drift}px)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 0.95,
                    }}
                >
                    <svg width={s.size} height={s.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="2" fill="#e5df69ff" stroke="#219c56ff" />
                        <g stroke="#218ba0ff" strokeWidth="0.9">
                            <path d="M12 2 L12 6" />
                            <path d="M12 18 L12 22" />
                            <path d="M2 12 L6 12" />
                            <path d="M18 12 L22 12" />
                            <path d="M4 4 L7 7" />
                            <path d="M17 17 L20 20" />
                            <path d="M4 20 L7 17" />
                            <path d="M17 7 L20 4" />
                        </g>
                    </svg>
                </div>
            ))}
        </div>
    );
}